import React, { useState, useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import debounce from "lodash.debounce";
import { filterContests, updateSearchingAction } from "../../store/slices/contestSlice";

const Search = () => {
    const dispatch = useDispatch();
    const [searchTerm, setSearchTerm] = useState("");
    

    const debouncedSearch = useCallback(
        debounce((query) => {
            dispatch(filterContests(query));
        }, 300),
        [dispatch]
    );

    const handleChange = (e) => {
        const value = e.target.value;
        if (value == '') {
            dispatch(updateSearchingAction(false));
        } else {
            dispatch(updateSearchingAction(true));
        }

        setSearchTerm(value);
        debouncedSearch(value);
    };

    return (
        <div className="searchBox shadow-sm border">
            <input
                type="text"
                placeholder="Search"
                className="search-input"
                value={searchTerm}
                onChange={handleChange}
            />
        </div>
    );
};

export default Search;
